export enum UserRole {
  ADMIN = 'admin',
  AGENT = 'agent',
  CLIENT_ADMIN = 'client_admin',
  CLIENT_USER = 'client_user',
}

export const CLIENT_ROLES: ReadonlySet<string> = new Set([
  UserRole.CLIENT_ADMIN,
  UserRole.CLIENT_USER,
]);

export const CLIENT_ROLE_OPTIONS: ReadonlyArray<UserRole> = [
  UserRole.CLIENT_ADMIN,
  UserRole.CLIENT_USER,
];

export const CLIENT_ROLE_DESCRIPTIONS: Record<string, string> = {
  [UserRole.CLIENT_ADMIN]: "Full access including Billing & Integrations",
  [UserRole.CLIENT_USER]: "No access to Billing or Integrations",
};

export interface CompanyUser {
  user_id: number;
  firebase_uid: string;
  last_used_company_id: number;
  email: string;
  first_name: string;
  last_name: string;
  role: UserRole;
  membership_status: 'active' | 'disabled';
  company_count: number;
  company_names: string[];
  is_onboarded: boolean;
  last_login_at: string | null;
  created_at: string;
  updated_at: string | null;
}

export interface CreateUserResponse {
  user: CompanyUser;
  temporaryPassword: string;
}

export type RegeneratePasswordResponse = CreateUserResponse;

export interface UsersListResponse {
  users: CompanyUser[];
  total: number;
}
